module.exports = __webpack_public_path__ + "img/logo_login.e05e16e7.png";